import { useImpersonate } from '@/api/auth.api';
import { useAuth } from '@/hooks/useAuth';
import { UserType } from '@/types/auth/UserType';
import { useCallback } from 'react';
import Modal from '../ui/Modal';
import { useTranslation } from '@/i18n';

interface AccessUserModalProps {
  closeModal: () => void;
  companyId: string;
  type: UserType;
}

const AccessUserModal = ({
  closeModal,
  companyId,
  type,
}: AccessUserModalProps) => {
  const { t } = useTranslation();
  const { impersonate } = useAuth();
  const { mutateAsync: impersonateReceiver } = useImpersonate();

  const accessUser = useCallback(async () => {
    const impersonationResult = await impersonateReceiver({
      type,
      companyId: companyId,
    });
    const { accessToken: token } = impersonationResult.data;
    impersonate(token);
  }, [companyId, impersonate, impersonateReceiver, type]);

  return (
    <Modal
      title={t('pages.admin.accessUserModal.title')}
      actionTitle={t('pages.admin.accessUserModal.actionTitle')}
      actionOnClick={accessUser}
      closeModal={closeModal}
      message={t('pages.admin.accessUserModal.message')}
    />
  );
};

export default AccessUserModal;
